import React, { Suspense } from 'react'
import FlexRow from '../FlexRow'
import Loading from '../Loading'

function SuspenseBoundary({ children }) {
  return (
    <Suspense
      fallback={
        <FlexRow justifyContent="center" width="100%" p="medium">
          <Loading />
        </FlexRow>
      }
    >
      {children}
    </Suspense>
  )
}

export default SuspenseBoundary
